import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useBooking } from '@/data/booking';
import EditNoteForm from '../coachList/nextBookings/EditNoteForm';

const NotesCard = () => {
  const [isEditing, setIsEditing] = useState(false);
  const params = useParams();
  const booking = useBooking(params.id);

  const onSuccess = async () => {
    await booking.mutate();
  };

  return (
    <Card>
      <CardContent className="p-4 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold">Customer Notes</h3>
          {!isEditing && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsEditing(!isEditing)}
            >
              Edit
            </Button>
          )}
        </div>

        {isEditing ? (
          <EditNoteForm
            booking={booking.data}
            setIsEditingNote={setIsEditing}
            onSuccess={onSuccess}
          />
        ) : (
          <p className="text-muted-foreground text-sm ">
            {booking.data.coachNotes || 'No notes yet'}
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default NotesCard;
